module.exports = {
  apiKey: "AIzaSyBf4NFbQqYkXilI5_y66PnLhKDfUbpotrU",
  authDomain: "fir-hiitandtabata.firebaseapp.com",
  databaseURL: "https://fir-hiitandtabata.firebaseio.com",
  projectId: "firebase-hiitandtabata",
  storageBucket: "firebase-hiitandtabata.appspot.com",
  messagingSenderId: "924167288963",
  appId: "1:924167288963:web:b78247a4dba2d5b77b43b6",
  measurementId: "G-P2Q3YN4230"
};

// module.exports = {
//   apiKey: "AIzaSyAGJtuu5kXBPsSgdg_EA62YUX__taSjzT8",
//   authDomain: "hiitandtabata-dev.firebaseapp.com",
//   databaseURL: "https://hiitandtabata-dev.firebaseio.com",
//   projectId: "hiitandtabata-dev",
//   storageBucket: "hiitandtabata-dev.appspot.com",
//   messagingSenderId: "129179235371",
//   appId: "1:129179235371:web:582baa1f362d5a808c666e",
//   measurementId: "G-XLLPFW63LB"
// };